const RANKING_ITEMS = [
  { rank: 1, title: '流浪地球3', tag: '科幻', hot: '热度 9.8', trend: 'up' },
  { rank: 2, title: '封神第二部', tag: '奇幻', hot: '热度 9.7', trend: 'up' },
  { rank: 3, title: '大江大河3', tag: '剧情', hot: '热度 9.5', trend: 'up' },
  { rank: 4, title: '长相思 第二季', tag: '古装', hot: '热度 9.4', trend: 'new' },
  { rank: 5, title: '庆余年3', tag: '权谋', hot: '热度 9.2', trend: 'hot' },
  { rank: 6, title: '狂飙2', tag: '犯罪', hot: '热度 9.1', trend: 'hot' },
];

const RANK_COLORS: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-accent-400/90 text-background-50',
  3: 'bg-accent-400/70 text-background-50',
};

const TREND_ICONS: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-400',
  new: 'ri-sparkling-line text-primary-400',
  hot: 'ri-fire-line text-accent-400',
};

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
            <i className="ri-trophy-line text-primary-400 text-lg"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              热度榜单
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
              实时热度排行，发现大家都在看的好片
            </p>
          </div>
        </div>

        <div className="bg-background-200/60 border border-background-300/40 rounded-2xl overflow-hidden">
          {RANKING_ITEMS.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 transition-colors cursor-pointer ${
                idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-300/30' : ''
              } hover:bg-background-200/40`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                  RANK_COLORS[item.rank] || 'bg-background-300/50 text-foreground-400'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 truncate">
                  {item.title}
                </h3>
              </div>
              <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-secondary-100/60 text-secondary-400 shrink-0">
                {item.tag}
              </span>
              <span className="text-xs text-foreground-500 shrink-0 hidden sm:block">
                {item.hot}
              </span>
              <span className="w-6 h-6 flex items-center justify-center shrink-0">
                <i className={TREND_ICONS[item.trend]}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}